export const THEME_SYSTEM = 'system';
export const THEME_LIGHT = 'light';
export const THEME_DARK = 'dark';

export const THEMES = [THEME_SYSTEM, THEME_LIGHT, THEME_DARK];
